import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import Booking from '../Components/Booking/Booking'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'

function BookingPage() {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title="Book Your Trip"
                subtitle="Find and book the perfect travel experience"
            />
            <div className="space">
                <Booking />
            </div>
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default BookingPage
